import React from "react";
import "./Footer.css";

function Footer() {
    return (
<section class="footer">
  <div class="footer-content">
    <h2 className="footer-text">Shokhrukh Karimkulov 2026</h2>
    <div className="footer-social-media">
          <a href="https://t.me/Shokhdesign_uxui" target="_blank" rel="noopener noreferrer" className="footer-custom-link">
          Telegram
          </a>
          <a href="https://www.instagram.com/shohruh_karimqulov/" target="_blank" rel="noopener noreferrer" className="footer-custom-link">
          Instagram
          </a>
          <a href="https://www.linkedin.com/in/shohruh-karimqulov-126ab21bb/" target="_blank" rel="noopener noreferrer" className="footer-custom-link">
          Linkedin
          </a>
          <a href="https://dribbble.com/Shohruh_Karimqulov" target="_blank" rel="noopener noreferrer" className="footer-custom-link">
          Dribbble
          </a>
          <a href="https://www.behance.net/shohruhkarimqu" target="_blank" rel="noopener noreferrer" className="footer-custom-link">
          Behance
          </a>
          </div>
      </div>
</section>
    );
}

export default Footer